import { BaseFiltersConfig } from 'features/common-elements';
import { FIELD_CONFIG } from 'configs/columns';
import { FilterableField } from '__generated__/globalTypes';

export const remittanceFiltersConfig = {
  deal_id: {
    type: 'list-input',
    displayName: 'Deal ID',
  },
  company_name: {
    type: 'list-input',
    displayName: 'Institution Name',
  },
  [FilterableField.current_balance_cents]: {
    type: 'range',
    displayName: FIELD_CONFIG.current_balance_cents.string,
    min: 1,
    max: 200000000,
    integer: true,
    prepare: (value: number) => value * 100,
  },
} as const satisfies BaseFiltersConfig;
